import React from "react";
import "./Roadmap.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import "react-vertical-timeline-component/style.min.css";


function Roadmap() {
	

	return (
		<div className="roadmap-container">
			<h2 className="section-header">Road Map</h2>
			<Tabs defaultActiveKey="user" className="mb-3 tabs">
				<Tab eventKey="user" title="For User">
					<VerticalTimeline className="tab-content">
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							contentArrowStyle={{
								borderRight: "7px solid  var(--color-secondary)",
							}}
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">Signup</h3>
							<p>Register and create a user account to access the program.</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Course Selection
							</h3>

							<p>Choose a course that aligns with your goals and interests.</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Knowledge Test on Selected Course
							</h3>

							<p>
								Take a test to assess your current knowledge of the chosen
								course's subject matter.
							</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Level Assignment Based On Knowledge Test
							</h3>

							<p>Get assigned a starting level based on your test results.</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Course Allocation Based On Level
							</h3>

							<p>Enroll in a course that matches your assigned skill level.</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">Start Course</h3>

							<p>Begin your selected course and start learning.</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">Final Test</h3>

							<p>Complete the course and take a final assessment.</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Course Completion & Get Certificate
							</h3>

							<p>
								Finish the course successfully and receive a certificate of
								completion.
							</p>
						</VerticalTimelineElement>
					</VerticalTimeline>
				</Tab>
				<Tab eventKey="instructor" title="For Instructor">
					<VerticalTimeline className="tab-content">
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							contentArrowStyle={{
								borderRight: "7px solid  var(--color-secondary)",
							}}
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">Signup</h3>
							<p>Register and create a user account to access the program.</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Selection of Course
							</h3>

							<p>
								Instructor have to choose a specific course, with its own name
								and description. The name provides a brief title, while the
								description outlines the course's content and objectives.
							</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Specify Target Audience
							</h3>

							<p>
								Users specify the intended audience or group for the course.
								This may include Undergraduate (UG), School-level, or
								Postgraduate (PG) students.
							</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Course Structure Generation
							</h3>

							<p>
								The system generates the structure of the chosen course, which
								includes organizing the content into modules and planning
								assessments (tests) that measure the learner's progress.
							</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Generate Course With Help Of AI
							</h3>

							<p>
								Artificial Intelligence (AI) is utilized to assist in creating
								the course content and resources.
							</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Review And Edit
							</h3>

							<p>
								After AI-generated content is created, instructors or content
								creators review and edit the materials to ensure accuracy,
								relevance, and alignment with the course objectives.
							</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "var(--color-secondary)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Final Test Creation (AI + Instructor)
							</h3>

							<p>
								A final test, which assesses the learner's comprehension of the
								course material, is created. This test may involve a combination
								of AI-generated questions and questions authored by instructors.
							</p>
						</VerticalTimelineElement>
						<VerticalTimelineElement
							className="vertical-timeline-element--work"
							iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}>
							<h3 className="vertical-timeline-element-title">
								Course Approval & Publish
							</h3>

							<p>
								Once the course content and assessments are finalized and
								reviewed, the course goes through an approval process. After
								approval, it is published and made available to the target
								audience for enrollment and learning.
							</p>
						</VerticalTimelineElement>
					</VerticalTimeline>
				</Tab>
			</Tabs>
		</div>
	);
}

export default Roadmap;
